import { http } from '../http';
import { BASE_URI } from '../../constants/ApiConstants';
import { registerQuery, useQuery } from '../../utils/DataFetchingClient';
export const FETCH_TRACK_PUBLIC_CERT_URLS = registerQuery({
  fieldName: 'track_public_cert_urls',
  args: ['trackId'],

  fetcher({
    trackId
  }) {
    return http.get(`${BASE_URI}/progress/tracks/${trackId}/public-images`).then(response => {
      return response;
    });
  }

});
export const useAchievementImages = ({
  trackId
}) => {
  const {
    data: images,
    loading: imagesLoading,
    error: imagesError
  } = useQuery(FETCH_TRACK_PUBLIC_CERT_URLS, {
    fetchPolicy: 'network-only',
    variables: {
      trackId
    },
    skip: !trackId
  });
  return {
    images: images || {},
    imagesLoading,
    imagesError
  };
};